/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { HeaderApp } from "components/Header";
import { HomeContent } from "components/HomeContent";

import * as Styled from "./styles";
import { Autocomplete, Container, TextField } from "@mui/material";
import { useMetrus } from "shared/providers";
import { useInsurance } from "shared/hooks/useInsurance";

const HomePage: React.FC = () => {
  const {
    step,
    setStep,
    setInsuranceIdNext,
    insuranceIdNext,
    setProviderId,
    setSpecialistId,
    setDisabledCity,
    setCityId,
    setRegionName,
    setNeighId,
    setDisabledNeigh,
    setState,
    setNameProviderId,
    setPreferr,
    setPage,
    setPlanShow,
  } = useMetrus();
  const { insurance } = useInsurance();

  const selectPlan = (n: number) => {
    setInsuranceIdNext(n);
    if (step > 1) {
      setStep(1);
    }
  };

  const removeNumbers = (value: string) => {
    const separate = value.split("-");

    return `${separate[2]} - ${separate[3]}`;
  };

  React.useEffect(() => {
    if (insuranceIdNext !== 0) {
      setStep(2);
    }
  }, [insuranceIdNext]);

  return (
    <>
      <HeaderApp />
      <Styled.Header>
        <Container maxWidth="xl">
          <Styled.CenterTitleFlex>
            <Styled.HeaderCenterTitle>
              <Styled.HeaderTitle>Consulta de</Styled.HeaderTitle>
              <Styled.HeaderSubTitle>rede credenciada</Styled.HeaderSubTitle>
              <Styled.HeaderText>
                Encontre consultórios, clínicas, hospitais, laboratórios, com
                médicos de várias especialidades.
              </Styled.HeaderText>
              <Styled.SelectPlan>
                <Autocomplete
                  disableClearable
                  options={insurance}
                  fullWidth
                  onChange={(_, options) => {
                    selectPlan(options?.value as number);
                    setPlanShow(removeNumbers(options.label as string));
                    setPage(1);
                    setProviderId("");
                    setSpecialistId("");
                    setRegionName("");
                    setNeighId("");
                    setDisabledNeigh(true);
                    setDisabledCity(true);
                    setState("");
                    setCityId("");
                    setNameProviderId("");
                    setPreferr("NOT_DEFINED");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      label="Escolha o seu plano"
                      sx={{
                        margin: "0 !important",
                      }}
                    />
                  )}
                />
              </Styled.SelectPlan>
            </Styled.HeaderCenterTitle>
          </Styled.CenterTitleFlex>
        </Container>
      </Styled.Header>
      <HomeContent />
    </>
  );
};

export { HomePage };
